import { render, staticRenderFns } from "./GiftCardPayment.vue?vue&type=template&id=6bfe5254&scoped=true"
import script from "./GiftCardPayment.vue?vue&type=script&lang=js"
export * from "./GiftCardPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe5254",
  null
  
)

export default component.exports